import { render, staticRenderFns } from "./Nurses.vue?vue&type=template&id=3bc08d1a&"
import script from "./Nurses.vue?vue&type=script&lang=js&"
export * from "./Nurses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports